import { useMemo } from 'react';
import type { VariantOf } from 'variant';
import type { SelectGroup, SelectOption } from '@wix/cli-ui-kit';
import { match, variant } from 'variant';

const DevCenterGenerateFlow = variant({
  DashboardPage: {},
  DashboardPlugin: {},
  DashboardMenuPlugin: {},
  DashboardModal: {},
  Event: {},
  ServicePlugin: {},
  EmbeddedScript: {},
  CustomElement: {},
  SitePlugin: {},
});

export type GenerateFlow = VariantOf<typeof DevCenterGenerateFlow>;

export const getGenerateFlowByKey = (
  key: keyof typeof DevCenterGenerateFlow
): SelectOption<GenerateFlow> => {
  return match(key, {
    DashboardPage: () => ({
      key,
      title: 'Dashboard Page',
      value: DevCenterGenerateFlow.DashboardPage(),
    }),
    DashboardModal: () => ({
      key,
      title: 'Dashboard Modal',
      value: DevCenterGenerateFlow.DashboardModal(),
    }),
    DashboardPlugin: () => ({
      key,
      title: 'Dashboard Plugin',
      value: DevCenterGenerateFlow.DashboardPlugin(),
    }),
    DashboardMenuPlugin: () => ({
      key,
      title: 'Dashboard Menu Plugin',
      value: DevCenterGenerateFlow.DashboardMenuPlugin(),
    }),
    CustomElement: () => ({
      key,
      title: 'Custom Element',
      value: DevCenterGenerateFlow.CustomElement(),
    }),
    EmbeddedScript: () => ({
      key,
      title: 'Embedded Script',
      value: DevCenterGenerateFlow.EmbeddedScript(),
    }),
    SitePlugin: () => ({
      key,
      title: 'Site Plugin',
      value: DevCenterGenerateFlow.SitePlugin(),
    }),
    Event: () => ({
      key,
      title: 'Event',
      value: DevCenterGenerateFlow.Event(),
    }),
    ServicePlugin: () => ({
      key,
      title: 'Service Plugin',
      value: DevCenterGenerateFlow.ServicePlugin(),
    }),
  });
};

export const useGenerateFlows = (): Array<SelectGroup<GenerateFlow>> => {
  return useMemo(() => {
    return [
      {
        title: 'Dashboard',
        items: [
          getGenerateFlowByKey('DashboardPage'),
          getGenerateFlowByKey('DashboardModal'),
          getGenerateFlowByKey('DashboardPlugin'),
          getGenerateFlowByKey('DashboardMenuPlugin'),
        ],
      },
      {
        title: 'Site',
        items: [
          getGenerateFlowByKey('EmbeddedScript'),
          getGenerateFlowByKey('CustomElement'),
          getGenerateFlowByKey('SitePlugin'),
        ],
      },
      {
        title: 'Backend',
        items: [
          getGenerateFlowByKey('Event'),
          getGenerateFlowByKey('ServicePlugin'),
        ],
      },
    ];
  }, []);
};
